var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("searchContainer", {
    attrs: { searchHandler: _vm.search, resetHandler: _vm.reset },
    scopedSlots: _vm._u([
      {
        key: "items",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("input-text", {
                  attrs: { options: { id: "note", label: "note" } },
                  model: {
                    value: _vm.filters.note,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "note", $$v)
                    },
                    expression: "filters.note"
                  }
                }),
                _c("select-wallet-transaction-types", {
                  attrs: {
                    options: {
                      id: "wallet_transaction_types",
                      label: "type",
                      placeholder: "placeholders.all",
                      multiple: true
                    }
                  },
                  model: {
                    value: _vm.filters.types,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "types", $$v)
                    },
                    expression: "filters.types"
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("input-date", {
                  attrs: {
                    options: { id: "created_from", label: "created_from" }
                  },
                  model: {
                    value: _vm.filters.created_from,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "created_from", $$v)
                    },
                    expression: "filters.created_from"
                  }
                }),
                _c("input-date", {
                  attrs: { options: { id: "created_to", label: "created_to" } },
                  model: {
                    value: _vm.filters.created_to,
                    callback: function($$v) {
                      _vm.$set(_vm.filters, "created_to", $$v)
                    },
                    expression: "filters.created_to"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }